'use strict'

var BN = require('bn.js')

module.exports = isBN

//Test if x is a bignumber
//FIXME: obviously this is the wrong way to do it
function isBN(x) {
  return x && typeof x === 'object' && Boolean(x.words)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/big-rat/lib/is-bn.js
// module id = WswQ
// module chunks = 0